// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3PJUX","item":"PaymentsMobile_item__2nksA","label":"PaymentsMobile_label__1l_CD","amount":"PaymentsMobile_amount__2ncGN"};